<template>
  <div class="vue-template">
    <navigation></navigation>
    <notifications group="global" />
    <div v-if="unreadMessagesCount">
      {{ unreadMessagesCount }} unread Messages
    </div>
    <div v-for="item in unreadMessages" :key="item.id">
      {{ item }}
    </div>
    <div class="App">
      <div class="vertical-center">
        <div class="inner-block">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import Navigation from '@/components/Navigation.vue';

export default {
  data() {
    return {
      user: null,
    };
  },
  components: {
    Navigation,
  },
  computed: {
    unreadMessages() {
      let unreadMessage = this.$store.getters.unreadMessages.filter(
        message => message.opened,
      );
      return unreadMessage;
    },
    unreadMessagesCount() {
      let filtered = this.$store.getters.unreadMessages.filter(
        message => message.opened,
      );
      let unreadMessage = filtered.length;
      return unreadMessage;
    },
  },
  created() {
    this.showNotification();
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
  },
  mounted() {
    this.$store.dispatch('fetchMessages');
  },
  methods: {
    displayNotification() {
      if (Notification.permission == 'granted') {
        navigator.serviceWorker.getRegistration().then(function(reg) {
          reg.showNotification('Hello world!');
        });
      }
    },
    showNotification() {
      Notification.requestPermission(function(result) {
        if (result === 'granted') {
          navigator.serviceWorker.ready.then(function(registration) {
            registration.showNotification('Vibration Sample', {
              body: 'Buzz! Buzz!',
              icon: '../images/touch/chrome-touch-icon-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-sample',
            });
          });
        }
      });
    },
  },
};
</script>
